const PATHS = {
    HOME: '/',
    GRAPH: '/graph',
};

export default PATHS;
